import { render, staticRenderFns } from "./AddressCard.vue?vue&type=template&id=477c5ac1&scoped=true&"
import script from "./AddressCard.vue?vue&type=script&async=true&lang=js&"
export * from "./AddressCard.vue?vue&type=script&async=true&lang=js&"
import style0 from "./AddressCard.vue?vue&type=style&index=0&id=477c5ac1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477c5ac1",
  null
  
)

export default component.exports